import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BlLoadingService } from '@blcloud/bl-ng-ui-component';
import { RedirectPageService } from './redirect-page.service';
import { LoginPageService } from '../login-page/login-page.service';
import { IOneTimeAccessCodeMgt } from '@blcloud/bl-datamodel';
import { ScreenService } from '@blcloud/bl-ng-share-module';
import { UrlUtils } from '@blcloud/bl-common';

@Component({
  selector: 'app-redirect-page',
  templateUrl: './redirect-page.component.html',
  providers: [RedirectPageService, LoginPageService]
})
export class RedirectPageComponent implements OnInit {

  @Input() userId: string;
  @Input() password: string;

  message: string;
  logout: string;
  isInitCheck = false;
  returnUrl: string = null;

  constructor(
    private title: Title,
    private route: ActivatedRoute,
    private redirectPageService: RedirectPageService,
    private loginPageService: LoginPageService,
    private loading: BlLoadingService,
    private screenService: ScreenService,
  ) {
    this.loginPageService.clearLoginCookie().subscribe();
    this.title.setTitle('モバイル認証ページ');
  }

  /**
   * 初期化
   */
  ngOnInit() {
    this.screenService.hideFrame();
    this.loginPageService.clearLoginCookie().subscribe();
    let ok = true;
    this.route.queryParams.subscribe(params => {
      if (params.rtnUrl !== undefined && UrlUtils.isSafeReturnUrl(params.rtnUrl, false)) {
        this.returnUrl = params.rtnUrl;
      } else {
        ok = false;
      }
      if (ok && params.code !== undefined) {
        // ワンタイム認証処理
        this.onLogin(params.code);
      } else {
        ok = false;
      }
      if (!ok) {
        this.onLoginError();
      }
    });
  }

  /**
   * ログイン処理
   */
  onLogin(code: string) {
    this.loading.show({});
    this.redirectPageService.getAuth(code).subscribe((res: IOneTimeAccessCodeMgt) => {
      this.loading.hide();
      // ログイン画面に遷移
      this.loginPageService.setLoginCookie(['', res.accessTokenId])
        .subscribe(() => {
          // リダイレクトURLに遷移
          window.open(this.returnUrl, '_self');
        });
    }, (_e) => {
      this.loading.hide();
      this.onLoginError();
    });
  }

  /** onLoginError : ログインエラー時の処理 */
  onLoginError() {
    // エラー画面を表示
    throw new Error('認証に失敗しました。QRコードを再生成して、新しいURLを取得してください。');
  }
}



// WEBPACK FOOTER //
// ./src/app/page/redirect-page/redirect-page.component.ts